import { gql } from "@apollo/client"

export const GET_TEMPLATE_VIEW_MODE = gql`
query getStaffProfileView($staff_id: ID!, $organization_id: ID!, $userId: ID!) {
  getStaffProfileView(
    staff_id: $staff_id
    organization_id: $organization_id
    userId: $userId
  ) {
    staff_id
    staff_name_first
    staff_name_last
    staff_email_address
    emailVerified
    creationTime
    lastSignInTime
    lastRefreshTime
    disabled
    staff_membership_ids {
      organization_name
      role_name
      staff_phone_number
      staff_credentials
      __typename
    }
    __typename
  }
}
`